module.exports = __webpack_public_path__ + "img/plus500.aef39612.png";